import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'xchange-home-search',
  templateUrl: './home-search.component.html',
  styleUrl: './home-search.component.scss'
})
export class HomeSearchComponent {
  @Input('label') label: string = '';
  @Input() type: any;
  searchValue: string= '';
  @Output() searchTextChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onSearchTextChanged(value:any){
    this.searchTextChanged.emit({searchText:value , type : this.type});
  }
}
